import React, { memo, useMemo } from 'react';

import { Box, Typography } from '@mui/material';
import { TableCDS } from '@sharedCR/coreDesignSystem/Table';
import PropTypes from 'prop-types';

import { getGroupProgressLabel } from '../../../Conditions.utils';
import { orderTaskRows, prepareTaskRow } from '../../ConditionTasksTable.utils';

import {
  groupHeadingLabelStyles,
  groupHeadingStyles,
  groupProgressStyles,
  groupStyles,
} from './ConditionTasksGroup.styles';

const ConditionTasksGroup = ({
  group,
  config,
  order,
  onRequestSort,
  expandedTaskId = null,
  expandedTaskContent = null,
  withHeading = true,
}) => {
  const rows = useMemo(() => {
    const prepared = group.tasks.map(prepareTaskRow);

    return orderTaskRows({ rows: prepared, order });
  }, [group.tasks, order]);

  const progressLabel = useMemo(() => getGroupProgressLabel(group.tasks), [group.tasks]);

  return (
    <Box sx={groupStyles}>
      {withHeading && (
        <Box sx={groupHeadingStyles}>
          <Typography color="text.primary" sx={groupHeadingLabelStyles} variant="medium14">
            {group.label}
          </Typography>
          <Typography color="text.secondary" sx={groupProgressStyles} variant="regular12">
            {progressLabel}
          </Typography>
        </Box>
      )}
      <TableCDS
        withNoAvailableMessage
        additionalRowContent={expandedTaskContent}
        additionalRowContentRowId={expandedTaskId}
        config={config}
        data={rows}
        order={order}
        onRequestSort={onRequestSort}
      />
    </Box>
  );
};

ConditionTasksGroup.propTypes = {
  group: PropTypes.shape({
    tasks: PropTypes.arrayOf(PropTypes.object).isRequired,
    label: PropTypes.string,
  }).isRequired,
  config: PropTypes.object.isRequired,
  order: PropTypes.object.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  expandedTaskId: PropTypes.string,
  expandedTaskContent: PropTypes.node,
  withHeading: PropTypes.bool,
};

export default memo(ConditionTasksGroup);
